import React from 'react';
import { IProps as IBlockProps } from './GlobalNotificationBlock.interface';
import GlobalNotificationBlockComponent from './GlobalNotificationBlock.component';
import TranslationComponent from '@/utils/TranslationComponent/TranslationComponent';
import * as translation from '@/utils/TranslationComponent/translation.utilities'
import { IconNames } from '@/elements/Icon/Icon.interface';

// Define the input props structure, which might come from a CMS or other data source
export interface IBlockInputProps {
    alertType: 'alert' | 'status'
    icon: IconNames
    description: string
    background: ThemeColors,
    buttons: any[],
    [key: string]: any;
}

/**
 * Maps input props (e.g., from a CMS) to the props expected by the GlobalNotificationBlock component.
 * @param input - The input props.
 * @returns The mapped props for the GlobalNotificationBlock component.
 */
const mapInputToProps = (input: IBlockInputProps): IBlockProps => {

    const { alertType, icon, description, background, buttons, ...rest } = input;

    return {
        icon: icon || undefined,
        alert: alertType || 'alert',
        text: description,
        buttons: buttons && buttons.length > 0 ? buttons.map((button: any) => translation.mapAnchorProps(button)) : undefined,
        backgroundColor: background || 'brand-3',
        ...rest
    }
};

const GlobalNotificationBlockTranslation: React.FC<IBlockInputProps> = (inputProps) => {
    return (
        <TranslationComponent
            inputProps={inputProps}
            TargetComponent={GlobalNotificationBlockComponent}
            mapProps={mapInputToProps}
        />
    );
};

export default GlobalNotificationBlockTranslation;
